export default function handleStickyComparisonTable() {
    let $element = $('.js-comparison-table');
    updateHeaderHeight($element);
    $(window).on('resize', () => {
        updateHeaderHeight($element);
    });
}

function updateHeaderHeight($element) {
    $element.css({'--options-height': $element.find('.js-sticky-comparison-table-header').outerHeight() + 'px'});
}